/**
 * Action items filter options for meeting list filtering
 */
export const MEETING_ACTION_ITEMS_FILTER = {
  HAS_ACTIONS: 'hasActions',
  HAS_PENDING: 'hasPending',
  HAS_OVERDUE: 'hasOverdue',
};

/**
 * Human-readable labels for action items filter
 */
export const MEETING_ACTION_ITEMS_FILTER_LABELS = {
  [MEETING_ACTION_ITEMS_FILTER.HAS_ACTIONS]: 'Has Action Items',
  [MEETING_ACTION_ITEMS_FILTER.HAS_PENDING]: 'Has Pending Actions',
  [MEETING_ACTION_ITEMS_FILTER.HAS_OVERDUE]: 'Has Overdue Actions',
};

/**
 * Array of action items filter options for use in dropdowns
 */
export const MEETING_ACTION_ITEMS_FILTER_OPTIONS = [
  { value: '', label: 'All Meetings' },
  { value: MEETING_ACTION_ITEMS_FILTER.HAS_ACTIONS, label: MEETING_ACTION_ITEMS_FILTER_LABELS[MEETING_ACTION_ITEMS_FILTER.HAS_ACTIONS] },
  { value: MEETING_ACTION_ITEMS_FILTER.HAS_PENDING, label: MEETING_ACTION_ITEMS_FILTER_LABELS[MEETING_ACTION_ITEMS_FILTER.HAS_PENDING] },
  { value: MEETING_ACTION_ITEMS_FILTER.HAS_OVERDUE, label: MEETING_ACTION_ITEMS_FILTER_LABELS[MEETING_ACTION_ITEMS_FILTER.HAS_OVERDUE] },
];
